import React from 'react'
import { useParams } from 'react-router'
import { MessageThreadPanel } from '@components/MessageThread/MessageThreadPanel'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import {
    ChannelContextProvider,
    DMChannelContextUserLookupProvider,
    SpaceContextProvider,
} from 'use-towns-client'

interface DMChannelRepliesProps {
    channelId?: string
    messageId?: string
    spaceId?: string
    parentRoute?: string
}

/**
 * Renders a DM thread panel with the necessary context providers.
 * Used by both touch routes (via route params) and desktop (via usePanels hook).
 *
 * Props can be passed directly or will fall back to route params.
 */
export function DMChannelReplies(props: DMChannelRepliesProps): React.JSX.Element {
    const params = useParams()
    const { data: abstractAccountAddress } = useMyAbstractAccountAddress()

    const channelId = props.channelId ?? params.channelSlug
    const messageId = props.messageId ?? params.messageId
    const spaceId = props.spaceId ?? params.spaceSlug

    if (!messageId || !channelId) {
        return <>Invalid Thread</>
    }

    return (
        <SpaceContextProvider shouldFetchBots spaceId={spaceId}>
            <DMChannelContextUserLookupProvider
                channelId={channelId}
                abstractAccountAddress={abstractAccountAddress}
            >
                <ChannelContextProvider channelId={channelId}>
                    <MessageThreadPanel
                        key={messageId}
                        messageId={messageId}
                        parentRoute={props.parentRoute}
                    />
                </ChannelContextProvider>
            </DMChannelContextUserLookupProvider>
        </SpaceContextProvider>
    )
}
